import { redirect, createFileRoute } from '@tanstack/react-router';
import { COMPANY_ENTRY_PATH } from '@/lib/company-entry';

export const Route = createFileRoute('/')({
	beforeLoad: () => {
		throw redirect({ to: COMPANY_ENTRY_PATH });
	},
});
